import _, { result } from 'lodash'
import vm from '../main'
import { API } from '../config'
import { httpClient as http } from '../services'

const internals = {}

internals.getCSV = (data) => {
  
  return http
    .get(`/trip/csv/download?type=${data.type}&startDate=${data.startDateIso}&endDate=${data.endDateIso}`)
    .then(response => {   
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${data.type}_${+new Date()}.csv`);
        document.body.appendChild(link);
        link.click();

    //   return response
    })
    .catch(error => {
      console.error('Get CSV Download.CSV Download-error:\n', error)
      throw error
    })
  
};


  export default internals;


// WEBPACK FOOTER //
// ./src/services/exportcsv.service.js